<template>
  <div id="zh-dialog" v-if="childzhDialogdialog">
    <div class="zh-dialog-box">
      <div class="zh-dialog-close" @click="close()">
        <svg class="icon zh-dialog-close-icon" style="" aria-hidden="true">
          <use xlink:href="#icon-guanbi1"></use>
        </svg>
      </div>
      <div class="zh-dialog-body">
          <slot name="main"></slot>
      </div>
      <div class="">

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name:'zh-dialog',
    props:{
      zhDialogdialog:null
    },
    watch:{
      zhDialogdialog:function (newval,oldval) {
        this.childzhDialogdialog = newval;
      }
    },
    data(){
      return{
        message:'',
        childzhDialogdialog:this.zhDialogdialog
      }
    },
    mounted(){
    },
    methods:{
      close(){
        this.$emit('update:zhDialogdialog',false)
      },
    }
  }
</script>

<style lang="less" scoped>
  #zh-dialog{
    .zh-dialog-box{
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 10000;
      background:rgba(0,0,0,0.5) ;
      .zh-dialog-body{
        position: relative;
        background: white;
        max-height: 700px;
        overflow-y: scroll;
        width: 60%;
        height: 25%;
        border-radius: 5px;
        box-sizing: content-box;
        padding: 40px;
        padding-bottom: 30px;
        margin: auto;
        animation:zh-owe-dialog-body-animation .5s;
        margin-top: 50%;
        &::-webkit-scrollbar{
          display: none;
        }
      }
      .zh-dialog-close{
        position: fixed;
        right: 0;
        top: 0;
        cursor: pointer;
        .zh-dialog-close-icon{
          color: white;
          width: 44px;
          height: 44px;
          &:active{
            color: #3fad7e;
            transition: all .5s;
          }
        }
      }
    }
    @keyframes zh-owe-dialog-body-animation {
      from{
        transform: scale(0.5);
      }
      to{
        transform: scale(1);
      }
    }

  }
</style>



// WEBPACK FOOTER //
// ui/zhdialog/src/zhdialog.vue